import * as React from 'react';
import { parse } from 'date-fns';
import cn from 'classnames';

import { useTheme } from '@websky/core/src/theme';
import { weatherIcons } from '@websky/core/src/Weather/icons';
import { getTemperaturePrefix } from '@websky/core/src/Weather/utils';
import { TemperatureUnits } from '@websky/graphql';
import { Props } from '@websky/core/src/Location/components/Location';
import { format } from '@websky/core/src/utils';

import * as theme from './Location.css';

const Location: React.FC<Props> = ({ type, airport, date, time, terminal, weather, onDetailsClick, className }) => {
	const { Location: css } = useTheme('Location');
	const flightDate = parse(date, 'yyyy-MM-dd', new Date());
	const weatherIcon = weather?.type && weatherIcons[weather.type];
	const image = airport?.city?.images?.panorama?.url ?? airport.images?.panorama?.url;

	return (
		<div className={cn(css.wrapper, theme.wrapper, className)}>
			<div className={theme.inner}>
				<div className={theme.route}>
					<div className={theme.dateTimeWrp}>
						<span className={cn(css.date, theme.date)}>{format(flightDate, 'dd MMM')}</span>
						<span className={theme.time}>{time}</span>
					</div>

					<div>
						<div className={cn(css.airport__name, theme.airportName)}>
							{airport.city?.name},
							<span>
								{airport.title} ({airport.iata?.toUpperCase()})
							</span>
						</div>
					</div>
				</div>
				<div className={cn(css.footer, theme.footer)} style={image ? { backgroundImage: `url(${image})` } : {}}>
					{weather && (
						<div className={cn(css.weather, theme.weather)}>
							{weatherIcon}

							<span className={css.weather__value}>
								{getTemperaturePrefix(weather.temperature)}
								{Math.abs(Math.round(weather.temperature))}&deg;
								{weather.measurement === TemperatureUnits.Fahrenheit && 'F'}
							</span>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default Location;
